import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image with Ken Burns Effect */}
      <motion.div
        initial={{ scale: 1 }}
        animate={{ scale: 1.08 }}
        transition={{ duration: 12, ease: 'linear', repeat: Infinity, repeatType: 'reverse' }}
        className="absolute inset-0"
      >
        <div
          className="w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/e3997aea5e261b172982f0eec3da098a.jpg)',
          }}
        ></div>
      </motion.div>

      {/* Dark Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-black/50"></div>

      {/* Content */}
      <div className="relative h-full flex items-center">
        <div className="max-w-[1600px] mx-auto px-4 lg:px-6 w-full">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="max-w-4xl"
          >
            {/* Eyebrow Tag */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.5 }}
              className="inline-block mb-3 sm:mb-4 lg:mb-6"
            >
              <span className="text-[10px] sm:text-xs uppercase tracking-[1.5px] sm:tracking-[2px] text-teal-400 font-semibold px-3 sm:px-4 py-1.5 sm:py-2 bg-teal-400/10 rounded-full backdrop-blur-sm border border-teal-400/20">
                Professional Water Tank Solutions
              </span>
            </motion.div>

            {/* Main Headline */}
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.7 }}
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.2] mb-3 sm:mb-4 lg:mb-6"
            >
              <span className="text-blue-400 block">SAMWON</span>
              <span className="text-emerald-400 block">TECH</span>
            </motion.h1>

            {/* Subheadline */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.9 }}
              className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-white/95 leading-relaxed mb-6 sm:mb-8 lg:mb-10 max-w-3xl font-light"
            >
              30년 전통의 물탱크 전문 제조업체<br />
              STS패널형, STS원통형, 라이닝 물탱크 제작 및 설치<br />
              최고의 품질과 기술력으로 안전한 물 저장 솔루션을 제공합니다
            </motion.p>

            {/* CTA Buttons */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 1.1 }}
              className="flex flex-wrap gap-3 sm:gap-4"
            >
              <button
                onClick={() => navigate('/products')}
                className="px-6 sm:px-8 lg:px-12 py-3 sm:py-3.5 lg:py-4 bg-teal-600 text-white text-sm sm:text-base font-semibold rounded-full hover:bg-teal-700 transition-all duration-300 flex items-center space-x-2 shadow-xl hover:shadow-2xl hover:scale-105 cursor-pointer whitespace-nowrap"
              >
                <span>제품 둘러보기</span>
                <i className="ri-arrow-right-line text-lg sm:text-xl"></i>
              </button>
              <button
                onClick={() => navigate('/quote')}
                className="px-6 sm:px-8 lg:px-12 py-3 sm:py-3.5 lg:py-4 bg-transparent text-white text-sm sm:text-base font-semibold rounded-full border-2 border-white hover:bg-white hover:text-gray-900 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                견적 문의하기
              </button>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;